import { WORDPRESS_API } from "shared/constants/api";


export const studentDocuments = [
  {
    id: "rezygnacja-edukacja-zdrowotna",
    title: "Rezygnacja z uczestnictwa w lekcjach edukacji zdrowotnej",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/rezygnacja-z-ed.zdr_.docx`
  },
  {
    id: "duplikat-swiadectwa-legitymacji",
    title: "Duplikat świadectwa i legitymacji szkolnej",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Duplikat-świadectwa-i-legitymacji-szkolnej-1.pdf`
  },
  {
    id: "ocena-zajecia-praktyczne",
    title: "Ocena z zajęć praktycznych",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Ocena-z-zajęć-praktycznych.pdf`
  },
  {
    id: "nagrody-uczniom",
    title: "Regulamin przyznawania nagród uczniom",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Regulamin-przyznawania-nagród-uczniom-1.pdf`
  },
  {
    id: "studniowka",
    title: "Regulamin studniówki",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Regulamin-studniówki.pdf`
  },
  {
    id: "szafki-szkolne",
    title: "Regulamin użytkowania szafek szkolnych",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Regulamin-użytkowania-szafek-szkolnych-1.pdf`
  },
  {
    id: "rozklad-lekcji",
    title: "Rozkład lekcji i przerw międzylekcyjnych",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Rozkład-lekcji-i-przerw-międzylekcyjnych-1.pdf`
  },
  {
    id: "skreslenie-z-listy",
    title: "Skreślenie z listy uczniów",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Skreślenie-z-listy-uczniów-1.pdf`
  },
  {
    id: "zwolnienie-wf",
    title: "Wniosek o zwolnienie z w-f",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/doc05230820220915121353.pdf`
  },
  {
    id: "opuszczanie-terenu-szkoly",
    title: "Zasady opuszczania przez uczniów terenu szkoły",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Zasady-opuszczania-przez-uczniów-terenu-szkoły-1.pdf`
  },
  {
    id: "zwolnienie-pks",
    title: "Zwolnienie PKS",
    href: `${WORDPRESS_API}/wp-content/uploads/2021/02/Zwolnienie-PKS.pdf`
  }
];